import { render, staticRenderFns } from "./BaseErrorBox.vue?vue&type=template&id=5d35377c&scoped=true"
import script from "./BaseErrorBox.vue?vue&type=script&lang=ts"
export * from "./BaseErrorBox.vue?vue&type=script&lang=ts"
import style0 from "./BaseErrorBox.vue?vue&type=style&index=0&id=5d35377c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d35377c",
  null
  
)

export default component.exports